<!--
 * @Description: 验证码登录、密码登录
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <div class="user-login__item user-login__main">
    <BaseTabs
      class="user-login__main-tabs"
      v-model="activeName"
      @tab-click="onTabClick"
    >
      <BaseTabPane label="验证码登录" name="bycode"></BaseTabPane>
      <BaseTabPane label="密码登录" name="bypassword"></BaseTabPane>
    </BaseTabs>
    <LoginForm
      ref="formRef"
      :itemList="itemList"
      :formData="currentForm"
      :pageType="LoginTypeEnum.MAIN"
    ></LoginForm>
    <div class="user-login__main-foot">
      <BaseButton :click="onLogin" class="user-login__main-loginbtn">
        立即登录
      </BaseButton>
      <div
        class="user-login__main-forget"
        :style="{
          justifyContent:
            activeName === 'bypassword' ? 'space-between' : 'flex-end'
        }"
      >
        <span v-if="activeName === 'bypassword'" @click="onForgotPwd">
          忘记密码
        </span>
        <p>
          没有账号，
          <span style="color: #fa8100" @click="onRegister">注册</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick, defineModel, onMounted } from 'vue';
import { BaseTabs, BaseTabPane, BaseButton } from 'xrk-components';
import { LoginForm } from '../components/login-base/index';

import type { FormRef, FormData } from '../types/index';
import { useSetup } from '../store';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { pwdLogIn, phoneLogin } from '../data-source/apis';

const FIELD_MAPPING = {
  bycode: [FormItemEnum.phone, FormItemEnum.agreement],
  bypassword: [FormItemEnum.account, FormItemEnum.pwd, FormItemEnum.agreement]
};

const model = defineModel();

const loginStore = useSetup();

const formRef = ref<FormRef>(null);
const activeName = ref<'bycode' | 'bypassword'>('bycode');
const itemList = ref([]);
const currentForm = ref<FormData>({});

const toForget = () => {
  model.value = 'login-forget';
};
const getItemList = () => {
  itemList.value = FIELD_MAPPING[activeName.value];
};

const setAllData = () => {
  currentForm.value = { ...currentForm.value, ...formRef.value.data };
  return currentForm.value;
};

const setLoginData = () => {
  loginStore.setLoginData({
    ...formRef.value.data,
    activeName: activeName.value
  });
};
const onRegister = () => {
  setLoginData();
  model.value = 'login-register';
};

const onTabClick = () => {
  setLoginData();
  nextTick(() => {
    setAllData();
    getItemList();
    formRef.value.resetFields();
  });
};

const onForgotPwd = () => {
  setLoginData();
  setAllData();
  toForget();
};

const onLogin = async () => {
  await formRef.value.validate();
  const form = setAllData();
  let userInfo;
  // 密码登录
  if (activeName.value === 'bypassword') {
    const { data } = await pwdLogIn({
      [FormItemEnum.account]: form[FormItemEnum.account],
      [FormItemEnum.pwd]: form[FormItemEnum.pwd]
    });
    userInfo = data;
  }
  if (activeName.value === 'bycode') {
    const { data } = await phoneLogin({
      [FormItemEnum.phone]: form[FormItemEnum.phone],
      [FormItemEnum.code]: form[FormItemEnum.code],
      forgetThePassword: 0
    });
    userInfo = data;
  }
  loginStore.setInfo(userInfo);
  loginStore.login();
};
onMounted(() => {
  if (loginStore.loginData.activeName) {
    const { activeName: activeName2, ...formData } = loginStore.loginData;
    activeName.value = activeName2;
    currentForm.value = { ...formData };
  }
  getItemList();
});
</script>

<style scoped lang="scss">
.user-login__main {
  ::v-deep .user-login__main-tabs {
    margin-top: 26px;
    margin-bottom: 18px;
    .is-active {
      color: #fa8100;
    }
    .xrk-tabs__item:hover {
      color: #fa8100;
    }
    .xrk-tabs__active-bar {
      background-color: #fa8100;
    }
  }

  .user-login__main-foot {
    height: 70px;
    .user-login__main-loginbtn {
      width: 368px;
      height: 40px;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
    }
    .user-login__main-forget {
      width: 100%;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #1a1a1a;
      margin-top: 16px;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
